import { useLogto } from '@logto/react';
import { type ReactNode, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useLogto();
  const { t } = useTranslation();

  // Once we've seen isAuthenticated=true, stay there. Background token
  // refreshes flip isLoading transiently and would otherwise unmount the
  // whole app subtree, nuking all state and triggering refetch storms.
  const everAuthedRef = useRef(false);
  if (isAuthenticated) everAuthedRef.current = true;

  if (everAuthedRef.current) return <>{children}</>;
  if (isLoading) return <div className="loading-screen">{t('loading')}</div>;
  return <Navigate to="/login" replace />;
}